import React from "react";
import OutOfRangeEventsGrid from "../../panels/registers/OutOfRangeEventsGrid";

const RegistersOutOfRangePage = () => {
    return (
        <OutOfRangeEventsGrid />
    )
}

export default RegistersOutOfRangePage;